function Step2SunsetMadnessHomepageContent({
 templateState,
 setTemplateField,

 heroImageFile,
 setHeroImageFile,

 secondHeroImageFile,
 setSecondHeroImageFile,

 existingHeroImageUrl,
 existingSecondHeroImageUrl,

 removeHeroImage,
 setRemoveHeroImage,

 removeSecondHeroImage,
 setRemoveSecondHeroImage,
}) {
 return (
  <div className="card">
   <h2>Sunset Madness homepage content</h2>

   <div className="row-2">
    <label className="field">
     <span>Hero title</span>
     <input
      value={templateState.hero_title || ""}
      onChange={(e) =>
       setTemplateField("hero_title", e.target.value)
      }
      placeholder="Sunset Madness"
     />
    </label>

    <label className="field">
     <span>Hero subtitle</span>
     <input
      value={templateState.hero_subtitle || ""}
      onChange={(e) =>
       setTemplateField("hero_subtitle", e.target.value)
      }
      placeholder="Basketball Tournaments for Young Adults"
     />
    </label>
   </div>

   <div className="row-2">
    <label className="field">
     <span>Register button text</span>
     <input
      value={templateState.hero_button_label || ""}
      onChange={(e) =>
       setTemplateField("hero_button_label", e.target.value)
      }
      placeholder="REGISTER"
      maxLength={30}
     />
    </label>

    <label className="field">
     <span>Register button link</span>
     <input
      value={templateState.hero_button_link || ""}
      onChange={(e) =>
       setTemplateField("hero_button_link", e.target.value)
      }
      placeholder="/register or https://..."
     />
    </label>
   </div>

   <div className="field">
    <span>Logo image</span>

    {existingHeroImageUrl &&
     !heroImageFile &&
     !removeHeroImage ? (
     <div className="existing-file-row">
      <span className="existing-file-pill">
       Current logo uploaded
      </span>

      <a
       href={existingHeroImageUrl}
       target="_blank"
       rel="noreferrer"
       className="existing-file-link"
      >
       View
      </a>

      <button
       type="button"
       className="existing-file-remove"
       onClick={() => {
        setRemoveHeroImage(true);
        setHeroImageFile(null);
       }}
      >
       Remove
      </button>
     </div>
    ) : null}

    {removeHeroImage ? (
     <div className="existing-file-row">
      <span className="existing-file-pill">
       Logo image will be removed
      </span>

      <button
       type="button"
       className="existing-file-link"
       onClick={() => setRemoveHeroImage(false)}
      >
       Undo
      </button>
     </div>
    ) : null}

    <div className="file-row">
     <input
      id="sunset-madness-logo-upload"
      type="file"
      accept="image/*"
      className="file-hidden"
      onChange={(e) => {
       const file = e.target.files?.[0] || null;

       setHeroImageFile(file);

       if (file) {
        setRemoveHeroImage(false);
       }
      }}
     />

     <label
      htmlFor="sunset-madness-logo-upload"
      className="file-btn"
     >
      Choose File
     </label>

     <div className="file-name">
      {heroImageFile?.name || "No file chosen"}
     </div>
    </div>
   </div>

   <div className="field">
    <span>Background image</span>

    {existingSecondHeroImageUrl &&
     !secondHeroImageFile &&
     !removeSecondHeroImage ? (
     <div className="existing-file-row">
      <span className="existing-file-pill">
       Current background image uploaded
      </span>

      <a
       href={existingSecondHeroImageUrl}
       target="_blank"
       rel="noreferrer"
       className="existing-file-link"
      >
       View
      </a>

      <button
       type="button"
       className="existing-file-remove"
       onClick={() => {
        setRemoveSecondHeroImage(true);
        setSecondHeroImageFile(null);
       }}
      >
       Remove
      </button>
     </div>
    ) : null}

    {removeSecondHeroImage ? (
     <div className="existing-file-row">
      <span className="existing-file-pill">
       Background image will be removed
      </span>

      <button
       type="button"
       className="existing-file-link"
       onClick={() => setRemoveSecondHeroImage(false)}
      >
       Undo
      </button>
     </div>
    ) : null}

    <div className="file-row">
     <input
      id="sunset-madness-background-upload"
      type="file"
      accept="image/*"
      className="file-hidden"
      onChange={(e) => {
       const file = e.target.files?.[0] || null;

       setSecondHeroImageFile(file);

       if (file) {
        setRemoveSecondHeroImage(false);
       }
      }}
     />

     <label
      htmlFor="sunset-madness-background-upload"
      className="file-btn"
     >
      Choose File
     </label>

     <div className="file-name">
      {secondHeroImageFile?.name || "No file chosen"}
     </div>
    </div>
   </div>
  </div>
 );
}

export default Step2SunsetMadnessHomepageContent;